import React from 'react';
import {
  buildFilters,
  CATEGORY_META,
  categoryForApi,
  type QuickSetupFormState,
} from './types';
import { SourceChips } from '@/components/ui';

function row(label: string, value: React.ReactNode) {
  if (value == null || value === '' || value === false) return null;
  return (
    <div className="wizard-summary-row" key={label}>
      <dt>{label}</dt>
      <dd>{value}</dd>
    </div>
  );
}

function categoryDetails(form: QuickSetupFormState): React.ReactNode[] {
  switch (form.category) {
    case 'vehicles':
      return [
        row('Search text', form.search_text),
        row('Brand', form.brand),
        row('Model', form.model),
        row('Year', [form.year_min, form.year_max].filter(Boolean).join(' – ') || null),
        row('Price (EUR)', [form.price_min, form.price_max].filter(Boolean).join(' – ') || null),
        row('Mileage (km)', [form.mileage_min, form.mileage_max].filter(Boolean).join(' – ') || null),
        row('Fuel', form.fuel),
        row('Transmission', form.transmission),
        row(
          'Message templates',
          form.message_templates
            .split('\n')
            .map((s) => s.trim())
            .filter(Boolean)
            .join(', ') || null,
        ),
      ].filter(Boolean);
    case 'real_estate':
      return [
        row('Search text', form.search_text),
        row('City', form.city),
        row('Region', form.region),
        row('Price (EUR)', [form.price_min, form.price_max].filter(Boolean).join(' – ') || null),
        row('Area m²', [form.area_min, form.area_max].filter(Boolean).join(' – ') || null),
        row('Rooms', [form.rooms_min, form.rooms_max].filter(Boolean).join(' – ') || null),
        row('Property type', form.property_type || null),
      ].filter(Boolean);
    case 'jobs':
      return [
        row('Keyword', form.keyword),
        row('Location', form.location),
        row('Remote only', form.remote_only ? 'Yes' : null),
        row('Salary min', form.salary_min ? `€${form.salary_min}` : null),
      ].filter(Boolean);
    case 'marketplace':
      return [
        row('Search text', form.search_text),
        row('Price (EUR)', [form.price_min, form.price_max].filter(Boolean).join(' – ') || null),
        row('Condition', form.condition),
      ].filter(Boolean);
    case 'custom':
      return [
        row('Search text', form.search_text),
        row('Extra filters', form.custom_filters ? 'JSON / raw text' : null),
      ].filter(Boolean);
    default:
      return [];
  }
}

export default function WizardSummary({ form }: { form: QuickSetupFormState }) {
  const meta = CATEGORY_META[form.category];
  const filters = buildFilters(form);

  return (
    <div className="wizard-summary">
      <h3>Review alert</h3>
      <dl className="wizard-summary-grid">
        {row('Category', `${meta.icon} ${meta.title}`)}
        {row('API category', categoryForApi(form.category))}
        {row('Alert name', form.name)}
        {row('Telegram recipient', form.telegram_chat_id)}
        {row(
          'Sources',
          form.source_names.length ? (
            <SourceChips sources={form.source_names} variant="compact" />
          ) : null
        )}
        {row('Run scrape now', form.run_scrape ? 'Yes' : 'No')}
        {categoryDetails(form)}
      </dl>
      <details className="wizard-summary-filters">
        <summary>filters_json preview</summary>
        <pre>{JSON.stringify(filters, null, 2)}</pre>
      </details>
    </div>
  );
}
